import { host } from "config/api.config";
import { Alert } from "model/alert.model";
import { useHTTPClient } from "services/httpClient.service";

const url = `${host}/alert`

export type AlertListFilterDTO = {
    indicators?: string[],
    companies: string[],
    buildings?: string[],
    startDate?: Date,
    endDate?: Date,
}

export function useGetAlertsApi(){
    const {data, loading, error, get} = useHTTPClient<Alert[]>(url)

    async function getApi(filter:{companies: string[], indicators?: string[], startDate?: Date, endDate?: Date}) {
        console.log(`filters`, filter)
        return get({params: filter})
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}